<script>
  /**
   * @typedef {Object} Props
   * @property {number} [percent]
   */

  /** @type {Props} */
  let { percent = 0 } = $props();
</script>

<div class="wc-dam-cap__drop">
  <p class="wc-dam-cap__raintext">{percent ? percent : '0'}%</p>
</div>
